import { filter, find, isEmpty } from 'lodash';
import useClinicalRecordService from '../../../../services/clinicalRecordService';

export default function useEventList(patientUuid: string, tags: string[]) {
  const { record } = useClinicalRecordService(patientUuid);
  return filter(record?.clinicalHistory, (x) =>
    isEmpty(tags)
      ? isEmpty(x.tags)
      : // TODO: make sure if x.tags can be string[] then remove typeof
        !!find(x.tags, (tag) =>
          typeof tag !== 'string'
            ? tags.includes(tag?.name?.toLowerCase())
            : tags.includes(tag?.toLowerCase())
        )
  );
}
